import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
// ngrx store
import { Store } from "@ngrx/store";
import { take, catchError } from "rxjs/operators";
import { Subscription } from "rxjs";
// services
import { BookingService } from "../../../services/booking.service";
import { ApplePayService } from "../../../services/apple-pay.service";
// models
import { AppState } from "../../../models/app-state.interface";
// globals
import {
  APPLE_MERCHANT_COUNTRY_CODE,
  COUNTRY_CODES,
} from "../../../../shared/globals";
import { paymentType } from "app/booking/reducers/d2d-booking.reducer";

declare var ApplePaySession;

const config = {
  merchantCapabilities: ["supports3DS"],
  supportedNetworks: ["visa", "masterCard", "amex"],
};

@Component({
  selector: "app-apple-pay",
  standalone: true,
  templateUrl: "./apple-pay.component.html",
  styleUrls: ["./apple-pay.component.scss"],
})
export class ApplePayComponent implements OnInit {
  @Input() price;
  @Input() paymenttype; // should be 1 for apple pay
  @Input() isD2dService;
  @Input() showLoader;
  @Input() appCopy;
  @Input() selectedLanguage;
  @Input() disablePayButton;
  @Input() bookingState;
  @Input() bookingAmendType;

  @Output()
  handleApplePay: EventEmitter<any> = new EventEmitter();

  public applePaySdk: Promise<any>;
  public countryCodes = COUNTRY_CODES.all;
  public bookingType

  private _applePayComplete: Subscription;

  constructor(
    private _bookingService: BookingService,
    private _applePayService: ApplePayService,
    private _appStore: Store<AppState>
  ) {}

  ngOnInit(): void {
    this._applePayComplete =
      this._bookingService.applePaymentComplete$.subscribe((res) => {
        // // console.log("Apple Pay completed successfully, complete payment");
        if (res) {
          const result = {
            status: ApplePaySession.STATUS_SUCCESS,
          };
          this._applePayService.completePayment(result);

          // reset payment options & apple pay session
          this._applePayService.clearSession();
          this._appStore.dispatch(paymentType({ payload: 1 }));
        }
      });
      this.bookingType = this.bookingState.bookingDetails.bookingType;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe((s) => (state = s));
    return state;
  }

  handleApplePayClick() {
    this.handleApplePay.emit(true);
  }

  // when apple pay button is clicked
  onApplePay() {
    // // console.log("apple pay session started");

    const currentAppState = this.getState(this._appStore);
    const currencyCode = currentAppState.timeslotReducer.currency.code;

    let total_price = this.isD2dService
      ? this.getD2dDiscountPrice().toString()
      : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ( (this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
        ||(this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount.toString(); // for amend flow
    }

    const total_items = {
      label: "PortrLtd",
      type: "final",
      amount: total_price, // abc | ccd | refund | amend
    };

    const request = {
      currencyCode: currencyCode,
      countryCode: APPLE_MERCHANT_COUNTRY_CODE,
      merchantCapabilities: config.merchantCapabilities,
      supportedNetworks: config.supportedNetworks,
      total: total_items,
      requiredShippingContactFields : [
        'name','phone', 'email', 'postalAddress'
      ],


    };

    // // console.log("Apple pay session created with request", request);

    this._applePayService.createSession(request, total_items);

    // // console.log("Apple pay session will begin now!");
  }

  getD2dDiscountPrice() {
    const { totalD2dPrice } = this._bookingService.getD2dDiscountPrice(this.price);
    return +totalD2dPrice;
  }

  ngOnDestroy() {
    if (this._applePayComplete) {
      this._applePayComplete.unsubscribe();
    }
  }
}
